import React, { ReactNode, useEffect, useMemo } from 'react';
import { useField } from '../useField';
import { FieldRenderProps } from '../FieldRenderProps';
import { useFormContext } from '../../Form/Context';

export const Field = <T = any,>(props: FieldRenderProps<T>): ReactNode => {
    const { children, memoChild, required = false, isFulfilled } = props;

    const fieldInstance = useField<T>({
        id: props.id,
        name: props.name,
        description: props.description,
        onBlurValidate: props.onBlurValidate,
        onChangeValidate: props.onChangeValidate,
        onSubmitValidate: props.onSubmitValidate,
        initialValue: props.initialValue,
        required,
        isFulfilled,
    });

    const memoizedChildren = useMemo(
        () => {
            return children(fieldInstance);
        },
        memoChild ? memoChild.concat([fieldInstance]) : [fieldInstance]
    );

    return memoizedChildren;
};
